<!-- 
  Authors : initappz (Rahul Jograna)
  Website : https://initappz.com/
  App Name : Grocery Delivery App Ionic7 Capacitor
  This App Template Source code is licensed as per the
  terms found in the Website https://initappz.com/license
  Copyright and Good Faith Purchasers © 2023-present initappz.
-->
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
<div id="sign-in-button"></div>
<div class="bg-light min-vh-100 d-flex flex-row align-items-center">
  <c-container>
    <c-row class="justify-content-center">
      <c-col md="5">
        <c-card-group>
          <c-card class="p-4">
            <c-card-body>
              <form cForm *ngIf="util.user_login_with == 0">
                <h1>{{util.translate('Login')}}</h1>
                <p class="text-medium-emphasis">{{util.translate('Sign In to your account')}}</p>
                <c-input-group class="mb-3">
                  <span cInputGroupText>
                    <svg cIcon name="cilUser"></svg>
                  </span>
                  <input cFormControl type="email" [(ngModel)]="email" [placeholder]="util.translate('Email')"
                    [class]="submited== true && email =='' ?'validator_error':''"
                    [ngModelOptions]="{standalone: true}" />
                </c-input-group>
                <c-input-group class="mb-4">
                  <span cInputGroupText>
                    <svg cIcon name="cilLockLocked"></svg>
                  </span>
                  <input cFormControl [placeholder]="util.translate('Password')" type="password" [(ngModel)]="password"
                    [class]="submited== true && password =='' ?'validator_error':''"
                    [ngModelOptions]="{standalone: true}" />
                </c-input-group>
                <c-row>
                  <c-col xs="6">
                    <button cButton class="px-4" color="primary" (click)="onLogin()">
                      {{util.translate('Login')}}
                    </button>
                  </c-col>
                  <c-col class="text-right" xs="6">
                    <button cButton class="px-0" color="link" (click)="forgot()">
                      <span style="color: blue;">{{util.translate('Forgot password?')}}</span>
                    </button>
                  </c-col>
                </c-row>

                <c-row>
                  <c-col xs="6"></c-col>
                  <c-col xs="6">
                    <select class="form-control" [ngModelOptions]="{standalone: true}" [(ngModel)]="langId"
                      (change)="changeLanguages()">
                      <option [value]="item.id" *ngFor="let item of util.allLanguages"> {{item.name}} </option>
                    </select>
                  </c-col>
                </c-row>

              </form>

              <form cForm *ngIf="util.user_login_with == 1">
                <h1>{{util.translate('Login')}}</h1>
                <p class="text-medium-emphasis">{{util.translate('Sign In to your account')}}</p>
                <div class="row">
                  <div class="col-md-3">
                    <select class="form-control" [ngModelOptions]="{standalone: true}" [(ngModel)]="country_code">
                      <option [value]="item.dialling_code" *ngFor="let item of util.countrys"> +{{item.dialling_code}}
                      </option>
                    </select>

                  </div>
                  <div class="col-md-9">
                    <c-input-group class="mb-3">
                      <input cFormControl [placeholder]="util.translate('Phone Number')" [(ngModel)]="mobile"
                        [class]="submited== true && mobile =='' ?'validator_error':''"
                        [ngModelOptions]="{standalone: true}" />
                    </c-input-group>
                  </div>
                </div>
                <c-input-group class="mb-4">
                  <span cInputGroupText>
                    <svg cIcon name="cilLockLocked"></svg>
                  </span>
                  <input cFormControl [placeholder]="util.translate('Password')" type="password" [(ngModel)]="password"
                    [class]="submited== true && password =='' ?'validator_error':''"
                    [ngModelOptions]="{standalone: true}" />
                </c-input-group>
                <c-row>
                  <c-col xs="6">
                    <button cButton class="px-4" color="primary" (click)="phonePasswordLogin()">
                      {{util.translate('Login')}}
                    </button>
                  </c-col>
                  <c-col class="text-right" xs="6">
                    <button cButton class="px-0" color="link" (click)="forgot()">
                      <span style="color: blue;">{{util.translate('Forgot password?')}}</span>
                    </button>
                  </c-col>
                </c-row>

                <c-row>
                  <c-col xs="6"></c-col>
                  <c-col xs="6">
                    <select class="form-control" [ngModelOptions]="{standalone: true}" [(ngModel)]="langId"
                      (change)="changeLanguages()">
                      <option [value]="item.id" *ngFor="let item of util.allLanguages"> {{item.name}} </option>
                    </select>
                  </c-col>
                </c-row>

              </form>

              <form cForm *ngIf="util.user_login_with == 2">
                <h1>{{util.translate('Login')}}</h1>
                <p class="text-medium-emphasis">{{util.translate('Sign In to your account')}}</p>
                <div class="row">
                  <div class="col-md-3">
                    <select class="form-control" [ngModelOptions]="{standalone: true}" [(ngModel)]="country_code">
                      <option [value]="item.dialling_code" *ngFor="let item of util.countrys"> +{{item.dialling_code}}
                      </option>
                    </select>

                  </div>
                  <div class="col-md-9">
                    <c-input-group class="mb-3">
                      <input cFormControl [placeholder]="util.translate('Phone Number')" [(ngModel)]="mobile"
                        [class]="submited== true && mobile =='' ?'validator_error':''"
                        [ngModelOptions]="{standalone: true}" />
                    </c-input-group>
                  </div>
                </div>

                <c-row>
                  <c-col xs="6">
                    <button cButton class="px-4" color="primary" (click)="phoneOTPLogin()">
                      {{util.translate('Send OTP')}}
                    </button>
                  </c-col>
                  <c-col class="text-right" xs="6">
                    <button cButton class="px-0" color="link" (click)="forgot()">
                      <span style="color: blue;">{{util.translate('Forgot password?')}}</span>
                    </button>
                  </c-col>
                </c-row>

                <c-row>
                  <c-col xs="6"></c-col>
                  <c-col xs="6">
                    <select class="form-control" [ngModelOptions]="{standalone: true}" [(ngModel)]="langId"
                      (change)="changeLanguages()">
                      <option [value]="item.id" *ngFor="let item of util.allLanguages"> {{item.name}} </option>
                    </select>
                  </c-col>
                </c-row>

              </form>
            </c-card-body>
          </c-card>

        </c-card-group>
      </c-col>
    </c-row>
  </c-container>
</div>